import type { TrackResolutionResult, GeneratedPlaylist } from '../types';

export const DEV_MODE = import.meta.env.VITE_DEV_MODE === 'true';

const devOverrides = globalThis as typeof globalThis & {
  __HEALFM_MUSICKIT_AUTH__?: boolean;
  __HEALFM_MUSICKIT_STOREFRONT__?: string;
};

export const mockMusicKitInstance = {
  isAuthorized: devOverrides.__HEALFM_MUSICKIT_AUTH__ ?? true,
  storefrontId: devOverrides.__HEALFM_MUSICKIT_STOREFRONT__ ?? 'us',
  musicUserToken: 'mock-music-user-token',
  authorize: () => Promise.resolve(),
};

export function mockResolveIsrcs(isrcs: string[]): TrackResolutionResult {
  return {
    resolved: Object.fromEntries(isrcs.map((isrc, i) => [isrc, `mock-catalog-id-${i}`])),
    notFound: [],
  };
}

export function mockCreatePlaylist(playlist: GeneratedPlaylist): { id: string } {
  console.log('[DEV MODE] Creating mock playlist:', playlist.name);
  return { id: `p.mock-playlist-${Date.now()}` };
}

let devModeInitialized = false;
export function initDevMode(): void {
  if (DEV_MODE && !devModeInitialized) {
    devModeInitialized = true;
    console.log('%c[DEV MODE] Running with MusicKit stubs', 'color: #ffcc00; font-weight: bold');
  }
}
